import { DatasetExploreItem } from "@/types/dataset";

import { ChevronDown } from "lucide-react";
import { twMerge } from "tailwind-merge";

import { DatasetCardHeader } from "../dataset/datasetCard/datasetCardHeader";
import { DatasetCardSpatialInfo } from "../dataset/datasetCard/datasetCardSpatialInfo";
import Divider from "../ui/Divider";

type Props = {
  data: DatasetExploreItem;
  expanded: boolean;
  handleExpandCollapse: (data: DatasetExploreItem) => void;
};

export const DatasetCard = ({
  data,
  expanded,
  handleExpandCollapse
}: Props) => {
  return (
    <div
      className={twMerge(
        "group border rounded-lg bg-white-smoke",
        !expanded && "border-none"
      )}
    >
      <button
        className={twMerge(
          "flex flex-col font-sans border-[1px] rounded-lg p-4 gap-2 min-h-[114px] cursor-pointer justify-between relative transition-colors w-full",
          expanded ? "bg-teal-50 border-teal-200" : "bg-white border-gainsboro",
          "hover:bg-teal-50 hover:border-teal-200"
        )}
        onClick={() => handleExpandCollapse(data)}
      >
        <DatasetCardHeader
          data={data}
          active={expanded}
          showLogo
          rightIcon={
            <ChevronDown
              className={twMerge(
                "transition-transform",
                expanded && "rotate-180"
              )}
            />
          }
        />
        <div className="flex flex-col gap-1">
          <Divider
            className="bg-gainsboro w-full h-[1px]"
            lineClassName={twMerge(
              "group-hover:border-teal-200",
              expanded && "border-teal-200"
            )}
          />
          <DatasetCardSpatialInfo
            spatialType={data.spatial_aggregation_type}
            countryId={data.country_id}
            areaRegion="Nationwide"
            rightContent={
              <span className="text-[10px] text-grey">BVT Data</span>
            }
          />
        </div>
      </button>
      {/* Expanded content */}
      {expanded && (
        <div className="p-4 text-[11px] text-txtHeading">
          <div className="flex flex-col gap-2">
            <div className="grid grid-cols-[2fr_3fr]">
              <p className="font-semibold">Adm Area Selection:</p>
              <p>Indonesia → DKI Jakarta → Jakarta Pusat</p>
            </div>
            <div className="grid grid-cols-[2fr_3fr]">
              <p className="font-semibold">Attribute filter:</p>
              <div className="flex flex-col gap-2">
                <div>
                  <p>Brand:</p>
                  <p className="text-txtBody">
                    BRI, BNI, BCA, Bank Tabungan Nasional
                  </p>
                </div>
                <div>
                  <p>Service Level:</p>
                  <p className="text-txtBody">
                    Kantor Cabang Utama, Kantor Cabang Pembantu
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
